/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {Dropdown1} from '../../content/dropdown/Dropdown1'
import {useAuth} from "../../../../app/modules/auth";

type Props = {
  className?: string
  items?: number
}

const API_URL = process.env.REACT_APP_PUBLIC_URL

const documentItem = (title: string, fileURL: string, subText?: string, badgeText?: string) => {
    
return (
    <div className='d-flex align-items-sm-center mb-7'>
      {/* begin::Symbol */}
      <div className='symbol symbol-50px me-5'>
        <span className='symbol-label'>
          <img
            src={toAbsoluteUrl('/media/svg/files/pdf.svg')}
            className='h-50 align-self-center'
            alt=''
          />
        </span>
      </div>
      {/* end::Symbol */}
      {/* begin::Section */}
      <div className='d-flex align-items-center flex-row-fluid flex-wrap'>
        <div className='flex-grow-1 me-2'>
          <a href={`${API_URL}/documentation/${fileURL}`} className='text-gray-800 text-hover-primary fs-6 fw-bolder' download>
            {title}
          </a>
            {subText && <span className='text-muted fw-bold d-block fs-7'>{subText}</span>}
        </div>
          {badgeText && <span className='badge badge-light fw-bolder my-2'>{badgeText}</span>}
      </div>
      {/* end::Section */}
    </div>
  )
}

const ListsWidget4: React.FC<Props> = ({className, items = 6}) => {
    const { currentUser, userVerifyRoles, logout, auth } = useAuth()
  return (
    <div className='card card-xl mb-xl-8'>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label'>Documentation</span>
          <span className='text-muted mt-1 fw-bold fs-7'></span>
        </h3>
      </div>
      {/* end::Header */}
      {/* begin::Body */}
      <div className='card-body pt-5'>

          {userVerifyRoles(["Labor Editor"]) == true && (
              <>
                  {documentItem('Key to Industry Benefits Report Results', 'Key to Industry Benefits Report Results 2025.pdf', '2025')}
                  {documentItem('Labor Survey Data Submission Instructions', '2025 Labor Survey Data Submission Instructions.pdf', '2025')}
                  {documentItem('Labor Survey Report Access Instructions', '2025 Labor Survey Report Access Instructions.pdf', '2025')}
                  {documentItem('Corporate Specialized Data Submission Instructions', 'Corporate Specialized Data Submission Instructions 2025.pdf', '2025')}
                  {documentItem('Admin HR Job Codes', 'Admin HR Job Codes 2025.pdf', '2025')}
                  {documentItem('Corporate Office Job Codes', 'Corporate Office Job Codes 2025.pdf', '2025')}
                  {documentItem('Production Job Codes', 'Production Job Codes 2025.pdf', '2025')}
              </>
          )}

      </div>
      {/* end::Body */}
    </div>
  )
}

export {ListsWidget4}
